// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"T_dl","slider__element":"T_dm","itemSlider":"T_dn","itemSlider__slideWrapper":"T_dp","itemSlider__pagination":"T_dq","activeSlide":"T_dr"};